import React from 'react';
import { Box, TextField, Grid } from '@material-ui/core';
import { fmtThousand } from '@/utils/comUtil';
import DetailTable from '@/pages/order/order_detail/components/detailTable';
import { useIntl } from 'umi';
import CodeDetailStyled from './CodeDetailStyled';

const ConsumptionRecordDetail = (props) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const orderData = props.detail;
  const list = [
    {
      label: formatMessage({ id: 'order.order.detail.n02.lbl02' }),
      id: 'orderNo',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n02.lbl03' }),
      id: 'store',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n02.lbl04' }),
      id: 'storeName',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n02.lbl05' }),
      id: 'company',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n02.lbl06' }),
      id: 'orderType',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n02.lbl07' }),
      id: 'channel',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n02.lbl08' }),
      id: 'payment',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n02.lbl09' }),
      id: 'tradeTime',
    },
    {
      label: formatMessage({ id: 'order.order.detail.n02.lbl10' }),
      id: 'amountTotal',
      ftm: fmtThousand,
    },
    {
      label: formatMessage({ id: 'order.order.detail.n02.lbl11' }),
      id: 'amountPaid',
      ftm: fmtThousand,
    },
    {
      label: '原订单号',
      id: 'originalOrderNo',
    },
  ];
  return (
    <CodeDetailStyled>
      <Box className="first-section">
        <Grid container spacing={7} sx={{ gap: '36px 0', marginTop: 0 }}>
          {list.map((item, index) => {
            let value = orderData[item.id];
            if (item.ftm) {
              value = item.ftm(orderData[item.id]);
            }
            return (
              <Grid
                item
                xs={3}
                key={`vip${index}`}
                sx={{
                  paddingTop: '0!important',
                }}
              >
                <Box display="flex" flexDirection="column">
                  <TextField
                    id="filled-read-only-input"
                    label={
                      <Box className="text-detail-label">{item.label}</Box>
                    }
                    value={
                      orderData &&
                      (orderData[item.id] || orderData[item.id] === 0)
                        ? value
                        : ''
                    }
                    InputProps={{
                      readOnly: true,
                    }}
                    variant="standard"
                    disabled
                    className="text-detail-info"
                  />
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Box>
      <Box height={32}></Box>
      <Box className="second-section">
        <DetailTable orderData={orderData} devicesMinWidth="auto" />
      </Box>
    </CodeDetailStyled>
  );
};
export default ConsumptionRecordDetail;
